import _mapKeys from 'lodash/mapKeys';

const entriesWithAnnotations = (entries, annotations) => {
  const mapping = _mapKeys(annotations, 'test_entry_id');
  return entries
    .map(val => ({ ...val, matched: mapping[val.id] }))
    .sort((a, b) => a.order - b.order);
};

export default entriesWithAnnotations;
